<template>
	<div>
		<div class="columns is-multiline" style="margin-bottom: 10px;">
			<div class="column is-12">
				<div class="columns is-mobile">
					<div class="column is-6">
						<b-input v-model="newRow.FirstName" placeholder="First name" expanded @input="buildFullName"></b-input>
					</div>
					<div class="column is-6">
						<b-input v-model="newRow.LastName" placeholder="Last name" expanded @input="buildFullName"></b-input>
					</div>
				</div>
			</div>
			<div class="column is-10">
				<div class="columns is-mobile">
					<div class="column is-6">
						<b-input v-model="newRow.Email" placeholder="Email" expanded></b-input>
					</div>
					<div class="column is-6">
						<b-input v-model="newRow.Title" placeholder="Title" expanded></b-input>
					</div>
				</div>
			</div>
			<div class="column is-2">
				<b-button class="is-primary" @click="add" icon-left="plus">Add</b-button>
			</div>
		</div>
		<b-field label="Requested additional users"></b-field>
		<div v-if="added.length > 0">
			<b-table :data="added"
					 hoverable
					 mobile-cards>
				<b-table-column field="Name" label="Name" v-slot="props" sortable>
					{{ props.row.Name }}
				</b-table-column>
				<b-table-column field="Email" label="Email" v-slot="props" sortable>
					{{ props.row.Email }}
				</b-table-column>
				<b-table-column field="Title" label="Title" v-slot="props" sortable>
					{{ props.row.Title }}
				</b-table-column>
				<b-table-column v-slot="props" sortable width="50">
					<b-button class="is-secondary" @click="remove(props.row)" icon-left="trash"></b-button>
				</b-table-column>
			</b-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				added: [],
				newRow: {}
			}
		},
		methods: {
			add() {
				this.added.push(this.newRow);
				this.$emit("updateUsers", this.added);
				this.newRow = {};
			},
			remove(a) {
				var i = this.added.indexOf(a);
				if (i > -1) {
					this.added.splice(i, 1);
					this.$emit("updateUsers", this.added);
				}
			},
			clear() {
				this.added = [];
				this.newRow = {}
			},
			buildFullName() {
				var name = [];
				if (this.newRow.FirstName)
					name.push(this.newRow.FirstName);
				if (this.newRow.LastName)
					name.push(this.newRow.LastName);

				this.newRow.Name = name.join(" ");
			}
		}
	}
</script>
